/**
 * DesktopAccordion.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 데스크탑용 아코디언 컴포넌트
 * 
 * -----------------------------------------------------------------------------------------------
 */

import { ArrowLargeIcon, DownIcon } from 'common-modules/general/assets/Styles/Desktop/icon';
import { ResponseFAQList } from 'common-modules/general/API/support/types';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';
import React from 'react';
import styled from 'styled-components';
import InnerHTML from 'dangerously-set-html-content';

/**
 * 파일 다운로드 Styled-Component
 */
interface DownProps {
  href?: string;
  text?: string;
  children?: JSX.Element;
  round?: boolean;
}

const DownBtnWrapper = styled.div``;
const DownLink = styled.a`
  display: inline-block;
  padding: 0.75rem 1.875rem 0.8125rem 1.875rem;
  background-color: #fff;
  border-radius: 40px;
  &:hover,
  &:focus {
    span {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      color: #ff671d;
    }
  }
  &.no-round {
    padding: 0.6875rem 1.875rem 0.75rem 1.875rem;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }
`;
const Text = styled.span`
  font-family: 'SDGothicNeobTTF-bLt';
  font-size: 1rem;
  color: #333;
`;
const FileDownBtn: React.FC<DownProps> = ({ children, href = '#none', text, round }) => {
  return (
    <DownBtnWrapper className="btn-down-area">
      <DownLink className={round ? '' : 'no-round'} href={href} role="button" download>
        {children}
        <Text className="txt">{text}</Text>
      </DownLink>
    </DownBtnWrapper>
  );
};


/**
 * FAQ 아코디언 Component
 */
interface Props {
  faq: ResponseFAQList;
  active: boolean;

  setActiveNumber(no: string): void;
}
const AccordionContainer = styled.div`
  border-bottom: 1px solid #ccc;
  position: relative;
  width: 100%;
`;
const AccordionHeader = styled.div<{ open: boolean }>`
  display: block;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s;
  box-sizing: border-box;
  /* background-color: ${props => (props.open ? '#f7f7f7' : '#fff')}; */

  &:hover {
    background-color: #f7f7f7;
  }
  ${ArrowLargeIcon} {
    text-align: center;
    background-position: center;
    vertical-align: middle;
    width: 90px;
    height: 90px;
    transform: ${props => (props.open ? 'rotate(0)' : 'rotate(180deg)')};
    box-sizing: border-box;
  }
`;
const AccordionContent = styled.div<{ open: boolean }>`
  display: block;
  word-break: keep-all;
  box-sizing: border-box;
  background: #f7f7f7;
  overflow: hidden;
  padding: ${props => (props.open ? '2.5rem' : '0 2.5rem')};
  max-height: ${props => (props.open ? '5000px' : '0')};
  transition: 0.3s;
  &.active {
    height: auto;
    background-color: pink;
    max-height: auto;
  }
`;

const Icon1 = styled.div`
  width: 90px;
  height: 90px;
  line-height: 90px;
  color: #ff671d;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;
  font-size: 1.5rem;
  text-align: center;
`;
const Icon2 = styled.div`
  width: 50px;
  color: #999;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
  cursor: pointer;
  font-size: 1.5rem;
  text-align: left;
  margin-top: 0;
`;
const Type = styled.div`
  font-size: 1.125rem;
  width: 110px;
  text-align: left;
  display: inline-block;
  box-sizing: border-box;
  color: #999;
  vertical-align: middle;
`;
const Question = styled.div`
  font-size: 1.25rem;
  width: calc(100% - 180px);
  text-align: left;
  line-height: 1.5;
  font-family: 'SDGothicNeobTTF-dMd';
  vertical-align: middle;
  display: inline-block;
`;
const File = styled.div`
  width: calc(100% - 50px);
  display: inline-block;
  font-size: 1.125rem;
  line-height: 1.6666666;
  vertical-align: top;
`;
const Answer = styled.div`
  font-family: 'SDGothicNeobTTF-bLt';
  color: #333;
  margin-bottom: 14px;
  
  img {
    max-width: 100%;
    height: auto;
  }
`;

const Accordion: React.FC<Props> = ({ faq, active, setActiveNumber }) => {
  return (
    <AccordionContainer>
      <AccordionHeader onClick={() => setActiveNumber(active ? '' : faq.noSral)} open={active}>
        <Icon1>Q</Icon1>
        {/* <Type>{faq.faqType}</Type> */}
        <Question>{faq.faqTitle}</Question>
        <ArrowLargeIcon className="ico-up-arrow-large" />
      </AccordionHeader>
      <AccordionContent open={active}>
        <Icon2>A</Icon2>
        <File>
          <Answer>
            <InnerHTML html={faq.faqDesc} />
          </Answer>
          {faq.fullPath && (
            <FileDownBtn href={`${APIClientBaseURL.file}${faq.fullPath}`} round text="다운로드">
              <DownIcon />
            </FileDownBtn>
          )}
        </File>
      </AccordionContent>
    </AccordionContainer>
  );
};

export default Accordion;
